import { ISignatureOptions } from '@modeso/types__aumico-lib-annualreport-be';

export const DEFAULT_SIGNATURE_OPTIONS: ISignatureOptions = {
    hasSignature: true,
    hideNames: false,
    isCollectiveSignature: true,
    placeSignatureAfterAop: false,
    place: null,
    signature1: null,
    signature2: null,
    date: undefined,
};
